export const CATEGORIES = [
  { slug: "all", label: "All" },
  { slug: "human-apparel", label: "Human Apparel" },
  { slug: "dog-apparel", label: "Dog Apparel" },
  { slug: "accessories", label: "Accessories" },
  { slug: "matching-sets", label: "Matching Sets" },
  { slug: "coming-soon", label: "Coming Soon" },
];

export const COLLECTIONS = [
  { slug: "founders", label: "Founders Collection" },
  { slug: "weekend", label: "Weekend Collection" },
  { slug: "signature", label: "Signature Collection" },
  { slug: "walkies", label: "Walkies Collection" },
];

export const NAV_LINKS = [
  { to: "/shop", label: "Shop" },
  { to: "/pre-orders", label: "Pre-Orders" },
  { to: "/about", label: "About" },
  { to: "/size-guide", label: "Size Guide" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const formatPrice = (amount, currency = "AUD") =>
  new Intl.NumberFormat("en-AU", { style: "currency", currency }).format(amount);
